import { hooks } from '@approvalmax/utils';
import { useEffect, useMemo } from 'react';
import { useInfiniteGetXeroCounterparties, XeroCounterparty } from 'shared/data/webApp/v1';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import { activeContactIdQueryParam, searchValueQueryParam } from '../constants';

export const useContactList = () => {
    const company = useCompanyBasedOnUrl();

    const [activeContactId, setActiveContactId] = hooks.useQueryParam(activeContactIdQueryParam);

    const [searchValue] = hooks.useQueryParam(searchValueQueryParam);

    const { data, fetchNextPage, isFetching, isFetchingNextPage, updateCachedData } = useInfiniteGetXeroCounterparties(
        {
            path: { companyId: company.id },
            query: {
                offset: 0,
                limit: 20,
                nameFilter: searchValue,
            },
        },
        {
            keepPreviousData: true,
        }
    );

    useEffect(() => {
        const firstContact = data?.pages[0].items[0];

        if (!firstContact) {
            return;
        }

        if (!activeContactId) {
            setActiveContactId(firstContact.counterpartyId);
        } else {
            const isActiveContactInData = data?.pages.some((page) =>
                page.items.some((item) => item.counterpartyId === activeContactId)
            );

            if (!isActiveContactInData) {
                setActiveContactId(firstContact.counterpartyId);
            }
        }
    }, [data, activeContactId, setActiveContactId]);

    const activeContact = useMemo(() => {
        let activeContactData: XeroCounterparty | null = null;

        /**
         * Find data for selected contact to show it's card
         * for .. of loops are used to be able to stop loop if contact is found
         * and not run through all items
         */
        for (const page of data?.pages ?? []) {
            for (const contact of page.items) {
                if (contact.counterpartyId === activeContactId) {
                    activeContactData = contact;

                    break;
                }
            }

            if (activeContactData) {
                break;
            }
        }

        return activeContactData;
    }, [data, activeContactId]);

    return { data, fetchNextPage, isFetching, isFetchingNextPage, activeContact, updateCachedData };
};
